import React, {useState, useEffect} from "react";
import { InputText } from "commons/input-controls";
import s from "./create-report-template.module.scss"
import { StandartButton } from "commons/form-controls";

const CreateReportTemplate = (props) => {
    const [name, setName] = useState('');
    const [currentPage, setCurentPage] = useState(props.body.currentPage);
    const [showedItemsCount, setShowedItemsCount] = useState(props.body.showedItemsCount);

    useEffect(() => {
        setCurentPage(props.body.currentPage);
        setShowedItemsCount(props.body.showedItemsCount);
    }, [props]);

    const setTemplateName = (name) => {
        setName(name)
    }

    const copyTemplate = () => {

    }

    const createTemplate = () => {
        const parameters = {
            /*FONT_PARAMETERS: {
                font: "Arial",
                fontSize: 9,
                fontColour: "#000000",
                fontFormatting: "NORMAL"
            }*/
        }
        if(props.isCopy)
            props.copyTemplate(props.body.template, name, currentPage, showedItemsCount);
        else
            props.createReportConstructorTemplate(name, parameters, currentPage, showedItemsCount );
        props.modalShowToggle(false);
    }

    return (
        <div className={s.CreateReportTemplate}>
            <div className="formRow">
                <InputText labelText={props.getValue("TEMPLATE_NAME")} callback={setTemplateName}/>
            </div>
            <div className="formRow">
                <StandartButton disabled={!name || name == ''} title={props.getValue(props.isCopy ? 'CREATE_DUPLICATE' : 'CREATE_TEMPLATE')} callback={createTemplate}/>
            </div>
        </div>
    )
}

export default CreateReportTemplate;